import React from "react";
import { Box, TextField, MenuItem } from "@mui/material";

const DiveDetailsSection = ({
  environment,
  platform,
  environments,
  platforms,
  onChange,
}) => (
  <Box display="flex" gap={2}>
    <TextField
      select
      label="Dive type"
      value={environment}
      onChange={(e) => onChange("environment", e.target.value)}
      helperText="Please select dive type"
      fullWidth
    >
      {environments.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      select
      label="Dive platform"
      value={platform}
      onChange={(e) => onChange("platform", e.target.value)}
      helperText="Please select dive platform"
      fullWidth
    >
      {platforms.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  </Box>
);

export default DiveDetailsSection;
